/**
 *  @class
 *  @function ImageHotspot
 */
if (!customElements.get('image-hotspot')) {
    class ImageHotspot extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.hotspots = this.querySelectorAll('.thb-hotspot');
            this.target = this.querySelector('slide-show');
            this.productDrawer = this.querySelector(".product-drawer");
            this.flkty = Flickity.data(this.target);
            this.closeBtn = this.querySelector('.thb-close');
            this.handleOutsideClick = this.handleOutsideClick.bind(this);

            this.hotspots.forEach((hotspot, i) => {
                hotspot.addEventListener('click', this.onClick.bind(this, i, hotspot));
                hotspot.addEventListener('touchstart', this.onClick.bind(this, i, hotspot));
            });

            this.closeBtn.addEventListener('click', this.closeDrawer.bind(this));
            document.addEventListener('click', this.handleOutsideClick);
        }

        onClick(i, hotspot) {
            this.productDrawer.classList.add("active");
            document.querySelector('html').classList.add('disable-scroll');
            document.querySelector('#wrapper').classList.add("open-cc");
            [].forEach.call(this.hotspots, function (el) {
                el.classList.remove('active');
            });
            hotspot.classList.add('active');
            this.flkty.select(i);
        }

        closeDrawer() {
            this.productDrawer.classList.remove("active");
            document.querySelector('html').classList.remove('disable-scroll');
            document.querySelector('#wrapper').classList.remove("open-cc");
        }

        handleOutsideClick(e) {
            if (!this.productDrawer.classList.contains('active')) return;

            const isInsideDrawer = this.productDrawer.contains(e.target);
            const isHotspot = e.target.closest('.thb-hotspot');

            if (!isInsideDrawer && !isHotspot) {
                this.closeDrawer();
            }
        }
    }
    customElements.define('image-hotspot', ImageHotspot);
}
